import * as React from "react";
import * as selectors from "../../../util/selectors";
import { setFBLoadOrder } from "../actions/loadOrder";
import { CollectionGenerateError, CollectionParseError, } from "../types/collections";
import { findGameEntry } from "../gameSupport";
import { genCollectionLoadOrder, toExtendedLoadOrderEntry } from "../util";
import LoadOrderCollections from "../views/LoadOrderCollections";
export async function generate(api, state, gameId, stagingPath, modIds, mods) {
    const gameEntry = findGameEntry(gameId);
    if (gameEntry === undefined) {
        return;
    }
    let loadOrder;
    try {
        const profileId = selectors.lastActiveProfileForGame(api.getState(), gameEntry.gameId);
        if (profileId === undefined) {
            throw new CollectionGenerateError("Invalid profile");
        }
        const includedMods = modIds.reduce((accum, iter) => {
            if (mods[iter] !== undefined) {
                accum[iter] = mods[iter];
            }
            return accum;
        }, {});
        loadOrder = await genCollectionLoadOrder(api, gameEntry, includedMods, profileId);
    }
    catch (err) {
        return Promise.reject(err);
    }
    return Promise.resolve({ loadOrder });
}
export async function parser(api, gameId, collection, updateSet) {
    const state = api.getState();
    const profileId = selectors.lastActiveProfileForGame(state, gameId);
    if (profileId === undefined) {
        return Promise.reject(new CollectionParseError(collection, "Invalid profile id"));
    }
    updateSet.init(gameId, (collection.loadOrder ?? []).map(toExtendedLoadOrderEntry(api)));
    api.store.dispatch(setFBLoadOrder(profileId, collection.loadOrder));
    return Promise.resolve(undefined);
}
export function Interface(props) {
    return React.createElement(LoadOrderCollections, props, []);
}
